import React from 'react';

export const Minus = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '11'}
    height={height || '2'}
    viewBox="0 0 11 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.793945 1.66667V0.333332H10.1273V1.66667H0.793945Z"
      fill={color || '#30259B'}
    />
  </svg>
);
